export default __webpack_public_path__ + "static/media/8a708a0e0e9afcef8ab2be41c10b3ffb.svg";